var urlAjaxFormSend = "/ajax/cms/form",
    urlAjaxCommentSend = "/ajax/cms/comment",
    urlAjaxShopBookmarkUpdate = "/ajax/shop/bookmark/update",
    urlAjaxShopCartUpdate = "/ajax/shop/cart/update",
    urlAjaxShopShippingUpdate = "/ajax/shop/shipping/update",
    urlAjaxClientAddressUpdate = "/ajax/client/address/update",
    urlAjaxCampaignOptinUpdate = "/ajax/campaign/optin/add",
    urlAjaxMembershipMemberAdd = "/ajax/membership/member/add",
    urlAjaxMembershipCreditAdd = "/ajax/membership/credit/add",
    urlAjaxMembershipRegistrationCancel  = "/ajax/membership/registration/cancel",
    urlAjaxMembershipRegistrationAdd = "/ajax/membership/registration/add";

var loadingDot = "<div class=\"loadingDot\"><div class=\"loadingDotElement\"></div><div class=\"loadingDotElement\"></div><div class=\"loadingDotElement\"></div></div>";

// Helpers
function qs(sel, ctx)  { return (ctx || document).querySelector(sel); }
function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
function delegate(root, evt, sel, fn) {
    root.addEventListener(evt, function(e) {
        var t = e.target.closest(sel);
        if (t && root.contains(t)) fn.call(t, e);
    });
}
function postJson(url, data) {
    var body = (data instanceof URLSearchParams) ? data : new URLSearchParams(data);
    return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body,
    }).then(function(r) { return r.json(); });
}

// Shared functions (referenced by multiple sections)
function fctShopCartRefresh(cart) {
    qsa('.olympeCartCount').forEach(function(el)      { el.innerHTML = cart['count']; });
    qsa('.olympeCartCountTotal').forEach(function(el) { el.innerHTML = cart['countTotal']; });
    qsa('.olympeCartAmount').forEach(function(el)     { el.innerHTML = cart['amountIncVatShow'].toFixed(2) + ' €'; });
    if (cart['shippingStatus'] == 1) {
        qsa('.olympeCartShipping').forEach(function(el) { el.innerHTML = cart['shippingIncVatShow'].toFixed(2) + ' €'; });
    } else if (cart['shippingStatus'] == 2) {
        qsa('.olympeCartShipping').forEach(function(el) { el.innerHTML = 'Livraison gratuite'; });
    } else {
        qsa('.olympeCartShipping').forEach(function(el) { el.innerHTML = 'Erreur'; });
    }
    qsa('.olympeCartDiscount').forEach(function(el)  { el.innerHTML = cart['discountIncVatShow'].toFixed(2) + ' €'; });
    qsa('.olympeCartTotal').forEach(function(el)     { el.innerHTML = cart['totalIncVatShow'].toFixed(2) + ' €'; });
    qsa('.olympeCartVatValue').forEach(function(el)  { el.innerHTML = cart['vatShow'].toFixed(2) + ' €'; });
}

function fctShopClientAddressSample(option) {
    var s = '';
    s += option.dataset.fullname     ? '<p>' + option.dataset.fullname     + '</p>' : '';
    s += option.dataset.lineone      ? '<p>' + option.dataset.lineone      + '</p>' : '';
    s += option.dataset.linetwo      ? '<p>' + option.dataset.linetwo      + '</p>' : '';
    s += '<p>' +
        (option.dataset.postalcode ? option.dataset.postalcode + ' ' : '') +
        (option.dataset.city       ? option.dataset.city               : '') +
    '</p>';
    s += option.dataset.state        ? '<p>' + option.dataset.state        + '</p>' : '';
    s += option.dataset.country      ? '<p>' + option.dataset.country      + '</p>' : '';
    s += option.dataset.phone        ? '<p>' + option.dataset.phone        + '</p>' : '';
    s += option.dataset.instructions ? '<p>' + option.dataset.instructions + '</p>' : '';
    return s;
}

function fctAdressModalClean() {
    qsa('.olympeAdressModal .modalTop p.new').forEach(function(el)    { el.classList.remove('hide'); });
    qsa('.olympeAdressModal .modalTop p.edit').forEach(function(el)   { el.classList.add('hide'); });
    qsa('.olympeAdressModal .modalTop p.delete').forEach(function(el) { el.classList.add('hide'); });

    qsa('.olympeAdressModal .modalContent div.update').forEach(function(el) { el.classList.remove('hide'); });
    qsa('.olympeAdressModal .modalContent div.delete').forEach(function(el) { el.classList.add('hide'); });

    qsa('.olympeAdressModal .modalBottom span.new').forEach(function(el)    { el.classList.remove('hide'); });
    qsa('.olympeAdressModal .modalBottom span.edit').forEach(function(el)   { el.classList.add('hide'); });
    qsa('.olympeAdressModal .modalBottom span.delete').forEach(function(el) { el.classList.add('hide'); });

    qsa('.olympeAdressModal input[type="text"], .olympeAdressModal select, .olympeAdressModal textarea')
        .forEach(function(el) { el.value = ''; });
    qsa('.olympeAdressModal input[type="checkbox"]')
        .forEach(function(el) { el.checked = false; });

    qsa('.olympeShopClientAddressUpdate').forEach(function(el) { el.dataset.toselect = 'clientAddressSelect'; });
}

document.addEventListener('DOMContentLoaded', function() {

    // ── Mobile Menu ──────────────────────────────────────────────────────────
    qsa('.toggle-button').forEach(function(btn) {
        btn.addEventListener('click', function() {
            window.scrollTo(0, 0);
            if (this.classList.contains('active')) {
                this.classList.remove('active');
                qsa('nav.mainNav').forEach(function(nav) { nav.classList.remove('active'); });
                document.body.style.overflow = 'inherit';
            } else {
                this.classList.add('active');
                qsa('nav.mainNav').forEach(function(nav) { nav.classList.add('active'); });
                document.body.style.overflow = 'hidden';
            }
        });
    });
    qsa('.mainNav i').forEach(function(icon) {
        icon.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var subMenus = this.parentElement.parentElement.querySelectorAll(':scope > ul');
            if (this.classList.contains('active')) {
                this.classList.remove('active');
                subMenus.forEach(function(ul) { ul.classList.remove('active'); });
            } else {
                this.classList.add('active');
                subMenus.forEach(function(ul) { ul.classList.add('active'); });
            }
        });
    });

    // ── Gallery ──────────────────────────────────────────────────────────────
    var splideElms = qsa('.splide');
    if (splideElms.length) {
        splideElms.forEach(function(el) {
            var maxHeight = 0;
            el.querySelectorAll('img').forEach(function(img) {
                if (img.offsetHeight > maxHeight) maxHeight = img.offsetHeight;
            });
            new Splide(el, { type: 'loop', autoplay: true, pagination: false }).mount();
        });
    }

    // ── Login ────────────────────────────────────────────────────────────────
    delegate(document.body, 'click', 'form[name="registration_form"] button[type="submit"]', function(e) {
        e.preventDefault();
        var btn = this;
        btn.querySelectorAll('input').forEach(function(el) { el.readOnly = true; });
        btn.querySelectorAll('textarea').forEach(function(el) { el.readOnly = true; });
        if (typeof captchaKey !== 'undefined') {
            grecaptcha.ready(function() {
                grecaptcha.execute(captchaKey, { action: 'submit' }).then(function(token) {
                    document.getElementById('recaptchaResponse').value = token;
                    qs('form[name="registration_form"]').submit();
                });
            });
        } else {
            qs('form[name="registration_form"]').submit();
        }
    });

    // ── Reset ────────────────────────────────────────────────────────────────
    delegate(document.body, 'click', 'form[name="security_reset"] button[type="submit"]', function(e) {
        e.preventDefault();
        var btn = this;
        btn.querySelectorAll('input').forEach(function(el) { el.readOnly = true; });
        btn.querySelectorAll('textarea').forEach(function(el) { el.readOnly = true; });
        if (typeof captchaKey !== 'undefined') {
            grecaptcha.ready(function() {
                grecaptcha.execute(captchaKey, { action: 'submit' }).then(function(token) {
                    document.getElementById('recaptchaResponse').value = token;
                    qs('form[name="security_reset"]').submit();
                });
            });
        } else {
            qs('form[name="security_reset"]').submit();
        }
    });

    // ── Form (CMS generated forms) ───────────────────────────────────────────
    var generatedForm = [];
    delegate(document.body, 'submit', 'form[id^="generatedForm"]', function(e) {
        e.preventDefault();
        var id = this.dataset.id;
        generatedForm[id] = this;

        qsa('span.message').forEach(function(el) { el.innerHTML = ''; });
        generatedForm[id].querySelectorAll(':scope > input').forEach(function(el) { el.readOnly = true; });
        generatedForm[id].querySelectorAll(':scope > textarea').forEach(function(el) { el.readOnly = true; });

        if (typeof captchaKey !== 'undefined') {
            grecaptcha.ready(function() {
                grecaptcha.execute(captchaKey, { action: 'submit' }).then(function(token) {
                    document.getElementById('recaptchaResponse').value = token;
                    sendGeneratedForm(id, new FormData(generatedForm[id]));
                });
            });
        } else {
            sendGeneratedForm(id, new FormData(generatedForm[id]));
        }
    });

    function sendGeneratedForm(id, formData) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', urlAjaxFormSend, true);
        xhr.upload.onprogress = function(e) {
            if (e.lengthComputable) console.log((e.loaded / e.total * 100) + '% uploaded');
        };
        xhr.onload = function() {
            if (xhr.status === 200) {
                qsa('span.message').forEach(function(el) { el.innerHTML = 'Votre message &agrave; bien &eacute;t&eacute; envoy&eacute; !'; });
                generatedForm[id].querySelectorAll(':scope > input').forEach(function(el) {
                    el.value = '';
                    el.classList.remove('has-value');
                });
                var idInput = generatedForm[id].querySelector(':scope > input[name="id"]');
                if (idInput) idInput.value = id;
                generatedForm[id].querySelectorAll(':scope > textarea').forEach(function(el) {
                    el.value = '';
                    el.classList.remove('has-value');
                });
            } else {
                qsa('span.message').forEach(function(el) { el.innerHTML = 'Une erreur est survenue. Veuillez &eacute;ssaiez &agrave; nouveau !'; });
            }
            generatedForm[id].querySelectorAll(':scope > input').forEach(function(el) { el.readOnly = false; });
            generatedForm[id].querySelectorAll(':scope > textarea').forEach(function(el) { el.readOnly = false; });
        };
        xhr.send(formData);
    }

    // ── Comment ──────────────────────────────────────────────────────────────
    delegate(document.body, 'submit', 'form[id^="commentForm"]', function(e) {
        e.preventDefault();
        var thiz = this;
        var id = this.dataset.id;

        qsa('span.message').forEach(function(el) { el.innerHTML = ''; });
        thiz.querySelectorAll(':scope > input').forEach(function(el) { el.readOnly = true; });
        thiz.querySelectorAll(':scope > textarea').forEach(function(el) { el.readOnly = true; });

        var formData = new FormData(this);
        var xhr = new XMLHttpRequest();
        xhr.open('POST', urlAjaxCommentSend, true);
        xhr.upload.onprogress = function(e) {
            if (e.lengthComputable) console.log((e.loaded / e.total * 100) + '% uploaded');
        };
        xhr.onload = function() {
            if (xhr.status === 200) {
                qsa('span.message').forEach(function(el) { el.innerHTML = 'Votre message &agrave; bien &eacute;t&eacute; envoy&eacute; !'; });
                thiz.querySelectorAll(':scope > input').forEach(function(el) { el.value = ''; });
                var pageidInput = thiz.querySelector(':scope > input[name="pageid"]');
                if (pageidInput) pageidInput.value = id;
                thiz.querySelectorAll(':scope > textarea').forEach(function(el) { el.value = ''; });
            } else {
                qsa('span.message').forEach(function(el) { el.innerHTML = 'Une erreur est survenue. Veuillez &eacute;ssaiez &agrave; nouveau !'; });
            }
            thiz.querySelectorAll(':scope > input').forEach(function(el) { el.readOnly = false; });
            thiz.querySelectorAll(':scope > textarea').forEach(function(el) { el.readOnly = false; });
        };
        xhr.send(formData);
    });

    // ── Shop: quantity field on item page ────────────────────────────────────
    qsa('main.shopItem input.olympeShopCartItemQuantity').forEach(function(input) {
        input.addEventListener('change', function() {
            var upd = qs('.olympeShopCartItemUpdate[data-id="' + this.dataset.id + '"]');
            if (upd) upd.setAttribute('data-qty', this.value);
        });
    });
    qsa('.olympeShopCartItemUpdate').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            fctShopCartUpdate(this.dataset.action, this.dataset.id, this.getAttribute('data-qty'));
        });
    });

    function fctShopCartUpdate(action, itemId, qty) {
        if (waitShopCart) return;
        waitShopCart = true;
        postJson(urlAjaxShopCartUpdate, { itemId: itemId, qty: qty, action: action })
            .then(function(data) {
                waitShopCart = false;
                if (data['status'] === 'OK') {
                    console.log(data);
                    var unitEl = qs('.olympeShopCartItemAmountUnitIncVat[data-id="' + data['itemId'] + '"]');
                    var amountTot = (parseFloat(unitEl ? unitEl.innerHTML : 0) * data['qty']).toFixed(2);
                    var totEl = qs('.olympeShopCartItemAmountTotIncVat[data-id="' + data['itemId'] + '"]');
                    if (totEl) totEl.innerHTML = amountTot + '&euro;';

                    var buyEl = qs('.itemActionsBuy[data-id="' + data['itemId'] + '"]');
                    if (buyEl) buyEl.classList.add('inCart');

                    qsa('.olympeShopCartItemUpdate[data-id="' + data['itemId'] + '"]').forEach(function(el) {
                        el.classList.add('inCart', 'updating');
                    });
                    setTimeout(function() {
                        qsa('.olympeShopCartItemUpdate[data-id="' + data['itemId'] + '"]').forEach(function(el) {
                            el.classList.remove('updating', 'inCart');
                            if (action === 'update') el.classList.add('inCart');
                        });
                    }, 3000);
                    qsa('.olympeShopCartItemUpdate[data-id="' + data['itemId'] + '"]').forEach(function(el) {
                        var showLink = el.parentElement.querySelector('.olympeShowCartLink');
                        if (showLink) showLink.classList.remove('hide');
                    });

                    fctShopCartRefresh(data['cart']);

                    var mainEl = qs('main');
                    if (mainEl && mainEl.classList.contains('shopItem') && action === 'add') {
                        var qtyEl = qs('.olympeShopCartItemQuantity[data-id="' + data['itemId'] + '"]');
                        if (qtyEl) qtyEl.value = 1;
                        var qtyShow = qs('.olympeShopCartItemQuantityShow[data-id="' + data['itemId'] + '"]');
                        if (qtyShow) qtyShow.innerHTML = 1;
                        var aTotEl  = qs('.olympeShopCartItemAmountTotIncVat[data-id="'  + data['itemId'] + '"]');
                        var aUnitEl = qs('.olympeShopCartItemAmountUnitIncVat[data-id="' + data['itemId'] + '"]');
                        if (aTotEl && aUnitEl) aTotEl.innerHTML = aUnitEl.innerHTML;
                    }
                    if (mainEl && mainEl.classList.contains('shopCart') && action === 'delete') {
                        var listEl = qs('.olympeCartListElement[data-id="' + data['itemId'] + '"]');
                        if (listEl) listEl.remove();
                    }
                } else {
                    alert('ERROR : ajaxShopCartUpdate');
                }
                waitShopCart = false;
            })
            .catch(function() { console.log('error'); });
    }

    var waitShopCart = false;

    var waitShopShipping = false;
    var pendingShopShipping = null;
    function fctShopShippingUpdate(carrierId) {
        // Une seule requête à la fois : la dernière demande reçue entre-temps est rejouée ensuite
        if (waitShopShipping) {
            pendingShopShipping = carrierId;
            return;
        }
        waitShopShipping = true;

        var params = { carrierId: carrierId };
        // Pays de destination choisi dans le checkout (point relais ou adresse de livraison)
        var countryInput = document.querySelector('input[name="olympeShippingCountry"]');
        if (countryInput && countryInput.value) {
            params.country = countryInput.value;
        }

        postJson(urlAjaxShopShippingUpdate, params)
            .then(function(data) {
                if (data['status'] === 'OK') {
                    fctShopCartRefresh(data['cart']);
                } else {
                    alert('ERROR : fctShopShippingUpdate');
                }
                waitShopCart = false;
            })
            .catch(function() { console.log('error'); })
            .finally(function() {
                waitShopShipping = false;
                if (pendingShopShipping !== null) {
                    var next = pendingShopShipping;
                    pendingShopShipping = null;
                    fctShopShippingUpdate(next);
                }
            });
    }

    // ── Shop: Bookmark ───────────────────────────────────────────────────────
    var waitBookmark = false;
    qsa('.olympeShopBookmarkItemUpdate').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            if (waitBookmark) return;
            waitBookmark = true;
            var thiz = this;
            postJson(urlAjaxShopBookmarkUpdate, { itemId: thiz.dataset.id })
                .then(function(data) {
                    if (data['status'] === 'OK') {
                        if (data['action'] === 'add') {
                            thiz.classList.add('inBookmark');
                            var countEl = qs('.olympeShopBookmarkCount');
                            if (countEl) countEl.innerHTML = parseInt(countEl.innerHTML) + 1;
                        }
                        if (data['action'] === 'remove') {
                            if (document.body.classList.contains('bookmarks') &&
                                thiz.parentElement &&
                                thiz.parentElement.parentElement &&
                                thiz.parentElement.parentElement.classList.contains('elItemCard')) {
                                thiz.parentElement.parentElement.remove();
                            }
                            thiz.classList.remove('inBookmark');
                            var countEl2 = qs('.olympeShopBookmarkCount');
                            if (countEl2) countEl2.innerHTML = parseInt(countEl2.innerHTML) - 1;
                        }
                    } else {
                        alert('ERROR : ajaxShopBookmarkUpdate');
                    }
                    waitBookmark = false;
                })
                .catch(function() { console.log('error'); });
        });
    });

    // ── Shop: Cart quantity +/- buttons ──────────────────────────────────────
    qsa('.olympeShopCartItemQuantityIncrease,.olympeShopCartItemQuantityDecrease').forEach(function(btn) {
        btn.addEventListener('click', function() {
            var id       = this.dataset.id;
            var qtyInput = qs('.olympeShopCartItemQuantity[data-id="' + id + '"]');
            var qty      = parseInt(qtyInput.value);
            var max      = parseInt(qtyInput.getAttribute('max'));

            if (this.classList.contains('olympeShopCartItemQuantityIncrease') && qty < max) qty++;
            if (this.classList.contains('olympeShopCartItemQuantityDecrease') && qty > 1)   qty--;

            qtyInput.value = qty;
            qtyInput.setAttribute('value', qty);
            qtyInput.dispatchEvent(new Event('change'));

            var qtyShow = qs('.olympeShopCartItemQuantityShow[data-id="' + id + '"]');
            if (qtyShow) qtyShow.innerHTML = qty;
            var updBtn = qs('.olympeShopCartItemUpdate[data-id="' + id + '"]');
            if (updBtn) updBtn.setAttribute('data-qty', qty);

            var incBtn = qs('.olympeShopCartItemQuantityIncrease[data-id="' + id + '"]');
            var decBtn = qs('.olympeShopCartItemQuantityDecrease[data-id="' + id + '"]');

            if (qty != max) {
                this.classList.add('disabled');
                if (incBtn) { incBtn.classList.remove('disabled'); incBtn.removeAttribute('disabled'); }
            } else {
                if (incBtn) { incBtn.classList.add('disabled'); incBtn.setAttribute('disabled', 'disabled'); }
            }
            if (qty > 1) {
                if (decBtn) { decBtn.classList.remove('disabled'); decBtn.removeAttribute('disabled'); }
            } else {
                if (decBtn) { decBtn.classList.add('disabled'); decBtn.setAttribute('disabled', 'disabled'); }
            }
        });
    });

    var timeout = null;
    qsa('main.shopCart input.olympeShopCartItemQuantity').forEach(function(input) {
        input.addEventListener('change', function() {
            clearTimeout(timeout);
            qsa('.olympeCartAmount,.olympeCartShipping,.olympeCartDiscount,.olympeCartTotal,.olympeCartVatValue')
                .forEach(function(el) { el.innerHTML = loadingDot; });
            var totEl = qs('.olympeShopCartItemAmountTotIncVat[data-id="' + this.dataset.id + '"]');
            if (totEl) totEl.innerHTML = loadingDot;

            var itemId = this.dataset.id;
            var qty    = this.value;
            timeout = setTimeout(function() { fctShopCartUpdate('update', itemId, qty); }, 1000);
        });
    });

    // ── Shop: Checkout – carrier ─────────────────────────────────────────────
    qsa('input[name="olympeShippingCarrier"]').forEach(function(radio) {
        radio.addEventListener('change', function() { fctShopShippingUpdate(this.value); });
    });
    var addrForm = qs('.olympeShopAddressForm');
    if (addrForm) {
        addrForm.addEventListener('submit', function(e) {
            var shipSel = qs('select.olympeAddressListShipping');
            var invSel  = qs('select.olympeAddressListInvoicing');
            if (!shipSel || !shipSel.value || !invSel || !invSel.value) e.preventDefault();
        });
    }

    // ── Shop: Checkout – payment method ─────────────────────────────────────
    function updatePaymentDisplay() {
        var checked = qs('input[name="methodPayment"]:checked');
        var val = checked ? checked.value : null;
        var cardDiv       = qs('div.paymentCard');
        var bancontactDiv = qs('div.paymentBancontact');
        if (!cardDiv || !bancontactDiv) return;
        switch (val) {
            case 'card':
                cardDiv.style.display       = '';
                bancontactDiv.style.display = 'none';
                break;
            case 'bancontact':
                cardDiv.style.display       = 'none';
                bancontactDiv.style.display = '';
                break;
        }
    }
    qsa('input[name="methodPayment"]').forEach(function(radio) {
        radio.addEventListener('change', updatePaymentDisplay);
    });
    updatePaymentDisplay();

    // ── Shop: Address – add (sets toselect on update button) ─────────────────
    qsa('.olympeAddressAdd').forEach(function(btn) {
        btn.addEventListener('click', function() {
            console.log(this.dataset.toselect);
            var ts = this.dataset.toselect;
            qsa('.olympeShopClientAddressUpdate').forEach(function(el) { el.dataset.toselect = ts; });
        });
    });

    // ── Shop: Address – modify ───────────────────────────────────────────────
    qsa('.olympeAddressModify').forEach(function(btn) {
        btn.addEventListener('click', function() {
            qsa('.olympeAdressModal .modalTop p.new').forEach(function(el) { el.classList.add('hide'); });
            qsa('.olympeAdressModal .modalTop p.edit').forEach(function(el) { el.classList.remove('hide'); });
            qsa('.olympeAdressModal .modalBottom span.new').forEach(function(el) { el.classList.add('hide'); });
            qsa('.olympeAdressModal .modalBottom span.edit').forEach(function(el) { el.classList.remove('hide'); });

            function setVal(name, val) { var el = qs('input[name="' + name + '"]'); if (el) el.value = val; }
            setVal('olympeAddressUpdateAction', 'update');
            setVal('olympeAddressUpdateId', this.dataset.id);
            setVal('olympeAddressUpdateLabel', this.dataset.label);
            if (this.dataset.maininvoicing == 1) {
                var invEl = qs('input[name="olympeAddressUpdateMainInvoicing"]');
                if (invEl) invEl.checked = true;
            }
            if (this.dataset.mainshipping == 1) {
                var shipEl = qs('input[name="olympeAddressUpdateMainShipping"]');
                if (shipEl) shipEl.checked = true;
            }
            setVal('olympeAddressUpdateFullname', this.dataset.fullname);
            setVal('olympeAddressUpdateLineOne', this.dataset.lineone);
            setVal('olympeAddressUpdateLineTwo', this.dataset.linetwo);
            setVal('olympeAddressUpdatePostalCode', this.dataset.postalcode);
            setVal('olympeAddressUpdateCity', this.dataset.city);
            var ctrEl = qs('select[name="olympeAddressUpdateCountry"]');
            if (ctrEl) ctrEl.value = this.dataset.country;
            setVal('olympeAddressUpdatePhone', this.dataset.phone);
            var instrEl = qs('textarea[name="olympeAddressUpdateInstructions"]');
            if (instrEl) instrEl.innerHTML = this.dataset.instructions;
        });
    });

    // ── Shop: Address – delete ───────────────────────────────────────────────
    qsa('.olympeAddressDelete').forEach(function(btn) {
        btn.addEventListener('click', function() {
            qsa('.olympeAdressModal .modalTop p.new').forEach(function(el) { el.classList.add('hide'); });
            qsa('.olympeAdressModal .modalTop p.delete').forEach(function(el) { el.classList.remove('hide'); });
            qsa('.olympeAdressModal .modalBottom span.new').forEach(function(el) { el.classList.add('hide'); });
            qsa('.olympeAdressModal .modalBottom span.delete').forEach(function(el) { el.classList.remove('hide'); });
            qsa('.olympeAdressModal .modalContent div.update').forEach(function(el) { el.classList.add('hide'); });
            qsa('.olympeAdressModal .modalContent div.delete').forEach(function(el) { el.classList.remove('hide'); });

            var actionEl = qs('input[name="olympeAddressUpdateAction"]'); if (actionEl) actionEl.value = 'delete';
            var idEl     = qs('input[name="olympeAddressUpdateId"]');     if (idEl) idEl.value = this.dataset.id;

            var addrDiv = qs('.olympeAdressModal .modalContent div.delete div.address');
            if (addrDiv) {
                addrDiv.innerHTML = this.parentElement.parentElement.innerHTML;
                var actionsDiv = addrDiv.querySelector('div.actions');
                if (actionsDiv) actionsDiv.remove();
            }
        });
    });

    // ── Shop: Address – AJAX update ──────────────────────────────────────────
    var waitClientAddress = false;
    qsa('.olympeShopClientAddressUpdate').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            if (waitClientAddress) return;
            waitClientAddress = true;

            function getVal(sel) { var el = qs(sel); return el ? el.value : ''; }
            function isChecked(sel) { var el = qs(sel); return el ? el.checked : false; }

            postJson(urlAjaxClientAddressUpdate, {
                addressId:     getVal('input[name="olympeAddressUpdateId"]'),
                action:        getVal('input[name="olympeAddressUpdateAction"]'),
                label:         getVal('input[name="olympeAddressUpdateLabel"]'),
                mainInvoicing: isChecked('input[name="olympeAddressUpdateMainInvoicing"]'),
                mainShipping:  isChecked('input[name="olympeAddressUpdateMainShipping"]'),
                fullname:      getVal('input[name="olympeAddressUpdateFullname"]'),
                lineOne:       getVal('input[name="olympeAddressUpdateLineOne"]'),
                lineTwo:       getVal('input[name="olympeAddressUpdateLineTwo"]'),
                postalCode:    getVal('input[name="olympeAddressUpdatePostalCode"]'),
                city:          getVal('input[name="olympeAddressUpdateCity"]'),
                country:       (function() { var el = qs('select[name="olympeAddressUpdateCountry"]'); return el ? el.value : ''; })(),
                phone:         getVal('input[name="olympeAddressUpdatePhone"]'),
                instructions:  getVal('textarea[name="olympeAddressUpdateInstructions"]'),
            })
            .then(function(data) {
                waitClientAddress = false;
                if (data['status'] === 'OK') {
                    if (document.body.classList.contains('accountAdresses')) { location.reload(); return; }

                    var html = '';
                    data['addresses'].forEach(function(item, index) {
                        console.log(item);
                        console.log(index);
                        html +=
                            '<option' +
                            ' value="'            + item.id           + '"' +
                            ' data-label="'       + item.label        + '"' +
                            ' data-fullName="'    + item.fullName     + '"' +
                            ' data-lineOne="'     + item.lineOne      + '"' +
                            ' data-lineTwo="'     + item.lineTwo      + '"' +
                            ' data-postalCode="'  + item.postalCode   + '"' +
                            ' data-city="'        + item.city         + '"' +
                            ' data-state="'       + item.state        + '"' +
                            ' data-country="'     + item.country      + '"' +
                            ' data-phone="'       + item.phone        + '"' +
                            ' data-instructions="'+ item.instructions + '"' +
                            '>' + item.label + '</option>';
                    });

                    qsa('.olympeAddressList').forEach(function(select) {
                        var currentOption = select.value;
                        console.log('currentOption', currentOption);
                        select.innerHTML = html;
                        if (currentOption) {
                            select.value = currentOption;
                            select.dispatchEvent(new Event('change'));
                        } else {
                            console.log('else');
                            if (select.options.length > 0) {
                                select.value = select.options[select.options.length - 1].value;
                                select.dispatchEvent(new Event('change'));
                            }
                        }
                    });

                    fctAdressModalClean();
                } else {
                    alert('ERROR : ajaxClientAddressUpdate');
                }
                waitClientAddress = false;
            })
            .catch(function() { console.log('error'); });
        });
    });

    qsa('select.olympeAddressList').forEach(function(select) {
        select.addEventListener('change', function() {
            console.log('change');
            if (this.dataset.sample && this.options.length > 0) {
                var sampleDiv = qs('div.' + this.dataset.sample);
                if (sampleDiv) sampleDiv.innerHTML = fctShopClientAddressSample(this.options[this.selectedIndex]);
            }
        });
        select.dispatchEvent(new Event('change'));
    });

    qsa('.olympeAdressModal, .olympeAdressModalClose').forEach(function(el) {
        el.addEventListener('click', function() { fctAdressModalClean(); });
    });

    // ── Account: Orders ──────────────────────────────────────────────────────
    qsa('table.orders a.showOrderDetails').forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            this.classList.toggle('opened');
            qsa('tr[data-orderid="' + this.dataset.orderid + '"]').forEach(function(row) {
                row.classList.toggle('hide');
            });
        });
    });

    // ── Newsletter ───────────────────────────────────────────────────────────
    var newsletterForm = qs('form[name="olympeNewsletterRegisterForm"]');
    if (newsletterForm) {
        newsletterForm.addEventListener('submit', function(e) {
            e.preventDefault();
            qsa('.olympeNewsletterRegisterFormThx').forEach(function(el) { el.classList.add('hide'); });
            var formData = new URLSearchParams(new FormData(this));
            postJson(urlAjaxCampaignOptinUpdate, formData)
                .then(function() {
                    qsa('form[name="olympeNewsletterRegisterForm"] input').forEach(function(el) { el.value = ''; });
                    qsa('.olympeNewsletterRegisterFormThx').forEach(function(el) { el.classList.remove('hide'); });
                })
                .catch(function() { console.log('error'); });
        });
    }

    // ── Management: parameters ───────────────────────────────────────────────
    qsa('body.management .projectParameters input,' +
        'body.management .projectParameters textarea,' +
        'body.management .projectParameters option,' +
        'body.management .projectParameters checkbox,' +
        'body.management .projectParameters select').forEach(function(el) {
        el.addEventListener('change', function(e) {
            e.preventDefault();
            if (this.classList.contains('disabled')) return false;
            var thiz = this;
            postJson('/ajax/management/parameter/update', {
                partnerToken:   thiz.closest('form').dataset.partnertoken,
                projectId:      thiz.closest('form').dataset.projectid,
                parameterId:    thiz.closest('tr').dataset.parameterid,
                parameterValue: thiz.value,
            })
            .then(function(response) {
                console.log(response);
                if (response['status'] !== 'OK') alert('ERROR : ajaxManagementParameterUpdate');
            })
            .catch(function() { console.log('error'); });
        });
    });

    // ── Management: task check ───────────────────────────────────────────────
    qsa('body.management a.taskCheck').forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            if (this.classList.contains('disabled')) return false;
            var thiz = this;
            postJson('/ajax/management/task/check', {
                partnerToken: thiz.closest('form').dataset.partnertoken,
                projectId:    thiz.closest('form').dataset.projectid,
                taskId:       thiz.closest('tr').dataset.taskid,
            })
            .then(function(response) {
                console.log(response);
                if (response['status'] === 'OK') {
                    thiz.querySelectorAll('i').forEach(function(i) { i.classList.remove('active'); });
                    var target = thiz.querySelector(response['done'] ? 'i.true' : 'i.false');
                    if (target) target.classList.add('active');
                } else {
                    alert('ERROR : ajaxManagementTaskCheck');
                }
            })
            .catch(function() { console.log('error'); });
        });
    });

    // ── Management: modal item (open) ────────────────────────────────────────
    qsa('body.management a[data-modal="modal-item"]').forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            var self = this;
            function setById(id, attr) {
                var el = document.getElementById(id);
                var val = self.getAttribute(attr);
                if (el) el.value = (val !== null) ? val : '';
            }
            setById('modalContentId',                'data-id');
            setById('modalContentTitle',             'data-itemTitle');
            setById('modalContentLabel',             'data-itemLabel');
            setById('modalContentAmountExcVatShow',  'data-itemAmountExcVatShow');
            setById('modalContentAmountExcVat',      'data-itemAmountExcVat');
            setById('modalContentAmountIncVatShow',  'data-itemAmountIncVatShow');
            setById('modalContentAmountIncVat',      'data-itemAmountIncVat');
            setById('modalContentQty',               'data-itemQty');
            setById('modalContentUnit',              'data-itemUnit');
            setById('modalContentVat',               'data-itemVat');
            setById('modalContentAmountTotExcVatShow','data-itemAmountTotExcVatShow');
            setById('modalContentAmountTotExcVat',   'data-itemAmountTotExcVat');
            setById('modalContentAmountTotIncVatShow','data-itemAmountTotIncVatShow');
            setById('modalContentAmountTotIncVat',   'data-itemAmountTotIncVat');

            var modalEl = qs('div[data-modal="modal-item"]');
            if (this.getAttribute('data-itemTitle') === null) {
                var newDiv  = qs('.modalBottom div.new',  modalEl);
                var editDiv = qs('.modalBottom div.edit', modalEl);
                if (newDiv)  newDiv.classList.remove('hide');
                if (editDiv) editDiv.classList.add('hide');
                document.getElementById('modalContentQty').value = 1;
                document.getElementById('modalContentVat').value = 21;
            } else {
                var newDiv2  = qs('.modalBottom div.new',  modalEl);
                var editDiv2 = qs('.modalBottom div.edit', modalEl);
                if (newDiv2)  newDiv2.classList.add('hide');
                if (editDiv2) editDiv2.classList.remove('hide');
            }
        });
    });

    // ── Management: modal item (amount calculation) ──────────────────────────
    var modalItemEl = qs('div[data-modal="modal-item"]');
    if (modalItemEl) {
        modalItemEl.querySelectorAll('input').forEach(function(input) {
            input.addEventListener('change', function(e) {
                e.preventDefault();
                var invoiceDecimal = 2;
                var value = 0;
                var qty = document.getElementById('modalContentQty').value;
                console.log(qty);
                var vat = document.getElementById('modalContentVat').value / 100 + 1;
                console.log(vat);

                if (this.id === 'modalContentVat') {
                    value = document.getElementById('modalContentAmountExcVat').value;
                    document.getElementById('modalContentAmountIncVat').value = value * vat;
                    document.getElementById('modalContentAmountIncVatShow').value = (value * vat).toFixed(invoiceDecimal);
                    document.getElementById('modalContentAmountTotExcVat').value = value * qty;
                    document.getElementById('modalContentAmountTotExcVatShow').value = (value * qty).toFixed(invoiceDecimal);
                    document.getElementById('modalContentAmountTotIncVat').value = value * qty * vat;
                    document.getElementById('modalContentAmountTotIncVatShow').value = (value * qty * vat).toFixed(invoiceDecimal);
                }
                if (this.id === 'modalContentQty') {
                    value = document.getElementById('modalContentAmountIncVat').value;
                    var amountTotExcVat = value / vat * qty;
                    document.getElementById('modalContentAmountTotExcVat').value = amountTotExcVat;
                    document.getElementById('modalContentAmountTotExcVatShow').value = amountTotExcVat.toFixed(invoiceDecimal);
                    var amountTotIncVat = value * qty;
                    document.getElementById('modalContentAmountTotIncVat').value = amountTotIncVat;
                    document.getElementById('modalContentAmountTotIncVatShow').value = amountTotIncVat.toFixed(invoiceDecimal);
                }
                if (this.id === 'modalContentAmountExcVatShow') {
                    value = parseFloat(this.value);
                    document.getElementById('modalContentAmountExcVat').value = value;
                    this.value = value.toFixed(invoiceDecimal);
                    var aIncVat = value * vat;
                    document.getElementById('modalContentAmountIncVat').value = aIncVat;
                    document.getElementById('modalContentAmountIncVatShow').value = aIncVat.toFixed(invoiceDecimal);
                    var aTotExcVat = value * qty;
                    document.getElementById('modalContentAmountTotExcVat').value = aTotExcVat;
                    document.getElementById('modalContentAmountTotExcVatShow').value = aTotExcVat.toFixed(invoiceDecimal);
                    var aTotIncVat = value * qty * vat;
                    document.getElementById('modalContentAmountTotIncVat').value = aTotIncVat;
                    document.getElementById('modalContentAmountTotIncVatShow').value = aTotIncVat.toFixed(invoiceDecimal);
                }
                if (this.id === 'modalContentAmountIncVatShow') {
                    value = parseFloat(this.value);
                    var aExcVat = value / vat;
                    document.getElementById('modalContentAmountExcVat').value = aExcVat;
                    document.getElementById('modalContentAmountExcVatShow').value = aExcVat.toFixed(invoiceDecimal);
                    document.getElementById('modalContentAmountIncVat').value = value;
                    this.value = value.toFixed(invoiceDecimal);
                    var aTotExcVat2 = value / vat * qty;
                    document.getElementById('modalContentAmountTotExcVat').value = aTotExcVat2;
                    document.getElementById('modalContentAmountTotExcVatShow').value = aTotExcVat2.toFixed(invoiceDecimal);
                    var aTotIncVat2 = value * qty;
                    document.getElementById('modalContentAmountTotIncVat').value = aTotIncVat2;
                    document.getElementById('modalContentAmountTotIncVatShow').value = aTotIncVat2.toFixed(invoiceDecimal);
                }
                if (this.id === 'modalContentAmountTotExcVatShow') {
                    value = parseFloat(this.value);
                    var aExcVat2 = value / qty;
                    document.getElementById('modalContentAmountExcVat').value = aExcVat2;
                    document.getElementById('modalContentAmountExcVatShow').value = aExcVat2.toFixed(invoiceDecimal);
                    var aIncVat2 = value / qty * vat;
                    document.getElementById('modalContentAmountIncVat').value = aIncVat2;
                    document.getElementById('modalContentAmountIncVatShow').value = aIncVat2.toFixed(invoiceDecimal);
                    document.getElementById('modalContentAmountTotExcVat').value = value;
                    this.value = value.toFixed(invoiceDecimal);
                    var aTotIncVat3 = value * vat;
                    document.getElementById('modalContentAmountTotIncVat').value = aTotIncVat3;
                    document.getElementById('modalContentAmountTotIncVatShow').value = aTotIncVat3.toFixed(invoiceDecimal);
                }
                if (this.id === 'modalContentAmountTotIncVatShow') {
                    value = parseFloat(this.value);
                    var aExcVat3 = value / qty / vat;
                    document.getElementById('modalContentAmountExcVat').value = aExcVat3;
                    document.getElementById('modalContentAmountExcVatShow').value = aExcVat3.toFixed(invoiceDecimal);
                    var aIncVat3 = value / qty;
                    document.getElementById('modalContentAmountIncVat').value = aIncVat3;
                    document.getElementById('modalContentAmountIncVatShow').value = aIncVat3.toFixed(invoiceDecimal);
                    var aTotExcVat3 = value / vat;
                    document.getElementById('modalContentAmountTotExcVat').value = aTotExcVat3;
                    document.getElementById('modalContentAmountTotExcVatShow').value = aTotExcVat3.toFixed(invoiceDecimal);
                    document.getElementById('modalContentAmountTotIncVat').value = value;
                    this.value = value.toFixed(invoiceDecimal);
                }
            });
        });

        var addBtn    = qs('div[data-modal="modal-item"] .modalBottom div.new button.addItem');
        var editBtn   = qs('div[data-modal="modal-item"] .modalBottom div.edit button.editItem');
        var deleteBtn = qs('div[data-modal="modal-item"] .modalBottom div.edit button.deleteItem');
        if (addBtn)    addBtn.addEventListener('click',    function(e) { e.preventDefault(); managementItemUpdate(this, 'add'); });
        if (editBtn)   editBtn.addEventListener('click',   function(e) { e.preventDefault(); managementItemUpdate(this, 'update'); });
        if (deleteBtn) deleteBtn.addEventListener('click', function(e) { e.preventDefault(); managementItemUpdate(this, 'delete'); });
    }

    function managementItemUpdate(thiz, action) {
        var cValue = {
            title:               document.getElementById('modalContentTitle').value,
            label:               document.getElementById('modalContentLabel').value,
            amountExcVat:        document.getElementById('modalContentAmountExcVat').value,
            amountExcVatShow:    document.getElementById('modalContentAmountExcVatShow').value,
            amountIncVat:        document.getElementById('modalContentAmountIncVat').value,
            amountIncVatShow:    document.getElementById('modalContentAmountIncVatShow').value,
            qty:                 document.getElementById('modalContentQty').value,
            unit:                document.getElementById('modalContentUnit').value,
            vat:                 document.getElementById('modalContentVat').value,
            amountTotExcVat:     document.getElementById('modalContentAmountTotExcVat').value,
            amountTotExcVatShow: document.getElementById('modalContentAmountTotExcVatShow').value,
            amountTotIncVat:     document.getElementById('modalContentAmountTotIncVat').value,
            amountTotIncVatShow: document.getElementById('modalContentAmountTotIncVatShow').value,
        };
        var projectForm = qs('form#project');
        postJson('/ajax/management/item/update', {
            partnerToken: projectForm ? projectForm.dataset.partnertoken : '',
            projectId:    projectForm ? projectForm.dataset.projectid    : '',
            itemId:       document.getElementById('modalContentId').value,
            itemValue:    JSON.stringify(cValue),
            action:       action,
        })
        .then(function(response) {
            console.log(response);
            if (response['status'] === 'OK') {
                if (response['action'] === 'delete') {
                    var row = qs('.projectItems table.items tr[data-id="' + document.getElementById('modalContentId').value + '"]');
                    if (row) row.remove();
                }
                var closeBtn = qs('a.venus-modal-close');
                if (closeBtn) closeBtn.click();
            } else {
                alert('ERROR : ajaxManagementItemsUpdate');
            }
        })
        .catch(function() { console.log('error'); });
    }

    // ── Membership: add member ───────────────────────────────────────────────
    var olympeWaitingMembershipAddMember = false;
    qsa('.membershipModalAddmember .addMember').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            if (olympeWaitingMembershipAddMember) return;
            olympeWaitingMembershipAddMember = true;
            var modal = this.closest('.membershipModalAddmember');
            postJson(urlAjaxMembershipMemberAdd, {
                firstName: modal.querySelector('input[name="memberFirstName"]').value,
                lastName:  modal.querySelector('input[name="memberLastName"]').value,
                birthday:  modal.querySelector('input[name="memberBirthday"]').value,
            })
            .then(function(response) {
                if (response['status'] === 'OK') {
                    var memberSelect = qs('select[name="member"]');
                    var emptyOpt = memberSelect.querySelector('option[value=""]');
                    if (emptyOpt) emptyOpt.remove();
                    var opt = document.createElement('option');
                    opt.value       = response['data']['memberId'];
                    opt.textContent = response['data']['firstName'] + ' ' + response['data']['lastName'];
                    memberSelect.appendChild(opt);
                    memberSelect.value = response['data']['memberId'];
                    memberSelect.dispatchEvent(new Event('change'));
                    var closeBtn = modal.querySelector('.venus-modal-close');
                    if (closeBtn) closeBtn.click();
                } else {
                    alert('ERROR : ajaxMembershipAddMember');
                }
                olympeWaitingMembershipAddMember = false;
            })
            .catch(function() { console.log('error'); });
        });
    });

    // ── Membership: qty custom ───────────────────────────────────────────────
    delegate(document, 'click', 'input[name="qtyCustom"]', function() {
        this.parentElement.click();
        this.focus();
    });
    delegate(document, 'change', 'input[name="qtyCustom"]', function() {
        console.log(this.value);
        var span = this.closest('label').querySelector('span');
        console.log(span ? span.getAttribute('data-price') : null);
        if (span) span.innerHTML = (this.value * span.getAttribute('data-price')).toFixed(2);
    });

    // ── Membership: credit add ───────────────────────────────────────────────
    var olympeWaitingMembershipCreditAdd = false;
    qsa('form.membershipCreditAdd').forEach(function(form) {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            qsa('p.error', this).forEach(function(el) { el.classList.add('hide'); });

            if (this.querySelectorAll('input[name="qty"]:checked').length === 0) {
                var errEl = qs('p.error', this);
                if (errEl) { errEl.innerHTML = 'Veuillez sélectionner une option'; errEl.classList.remove('hide'); }
                return false;
            }
            var memberSel = qs('select[name="member"]', this);
            if (memberSel && memberSel.value === '') {
                console.log('pas de membre selectionné');
                var errEl2 = qs('p.error', this);
                if (errEl2) { errEl2.innerHTML = 'Aucun membre selectionné'; errEl2.classList.remove('hide'); }
                return false;
            }
            if (olympeWaitingMembershipCreditAdd) return;
            olympeWaitingMembershipCreditAdd = true;
            var formData = new URLSearchParams(new FormData(this));
            postJson(urlAjaxMembershipCreditAdd, formData)
                .then(function(response) {
                    if (response['status'] === 'OK') {
                        console.log('coucou');
                        console.log(response);
                        location.replace('/payment/' + response['data']['paymentUid']);
                    } else {
                        alert('ERROR : ajaxMembershipCreditAdd');
                    }
                    olympeWaitingMembershipCreditAdd = false;
                })
                .catch(function() { console.log('error'); });
        });
    });

    // ── Membership: registration add ─────────────────────────────────────────
    var olympeWaitingMembershipRegistrationAdd = false;
    qsa('form.membershipRegistrationAdd').forEach(function(form) {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            qsa('p.error', this).forEach(function(el) { el.classList.add('hide'); });
            var memberSel = qs('select[name="member"]', this);
            if (memberSel && memberSel.value === '') {
                console.log('pas de membre selectionné');
                var errEl = qs('p.error', this);
                if (errEl) { errEl.innerHTML = 'Aucun membre selectionné'; errEl.classList.remove('hide'); }
                return false;
            }
            if (olympeWaitingMembershipRegistrationAdd) return;
            olympeWaitingMembershipRegistrationAdd = true;
            var formData = new URLSearchParams(new FormData(this));
            postJson(urlAjaxMembershipRegistrationAdd, formData)
                .then(function(response) {
                    if (response['status'] === 'OK') {
                        if (response['statusMessage'] === 'PAYD_BY_CREDITS')    location.reload();
                        if (response['statusMessage'] === 'PAYD_BY_RECOVERIES') location.reload();
                        if (response['statusMessage'] === 'PAYD_BY_PAYMENT')    location.replace('/payment/' + response['data']['paymentUid']);
                    } else if (response['status'] === 'ERROR') {
                        if (response['statusMessage'] === 'NO_FREE_SLOT') location.reload();
                    } else {
                        alert('ERROR : ajaxMembershipRegistrationAdd');
                    }
                    olympeWaitingMembershipRegistrationAdd = false;
                })
                .catch(function() { console.log('error'); });
        });
    });

    var regShowCancelBtn = qs('div.olympeMembershipRegistrationShow button.cancel');
    if (regShowCancelBtn) {
        regShowCancelBtn.addEventListener('click', function() {
            var closeLink = qs('div.olympeMembershipRegistrationShow a.venus-modal-close');
            if (closeLink) closeLink.dispatchEvent(new MouseEvent('click'));
            var openLink = qs('a.venus-modal-open.olympeMembershipRegistrationCancel');
            if (openLink) openLink.dispatchEvent(new MouseEvent('click'));
        });
    }

    // ── Membership: registration cancel ──────────────────────────────────────
    var olympeWaitingMembershipRegistrationCancel = false;
    qsa('div.olympeMembershipRegistrationCancel button.cancel').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            if (olympeWaitingMembershipRegistrationCancel) return;
            olympeWaitingMembershipRegistrationCancel = true;
            var modal = this.closest('div.olympeMembershipRegistrationCancel');
            var regIdInput = modal.querySelector('input[name="registrationId"]');
            postJson(urlAjaxMembershipRegistrationCancel, {
                registrationId: regIdInput ? regIdInput.value : '',
            })
            .then(function(response) {
                if (response['status'] === 'OK') {
                    location.reload();
                } else {
                    alert('ERROR : urlAjaxMembershipRegistrationCancel');
                }
                olympeWaitingMembershipRegistrationCancel = false;
            })
            .catch(function() { console.log('error'); });
        });
    });

});
